import { render, staticRenderFns } from "./ValueSurvey.vue?vue&type=template&id=785eb05c"
import script from "./ValueSurvey.vue?vue&type=script&lang=ts"
export * from "./ValueSurvey.vue?vue&type=script&lang=ts"
import style0 from "./ValueSurvey.vue?vue&type=style&index=0&id=785eb05c&prod&module=true&lang=scss"
import style1 from "./ValueSurvey.vue?vue&type=style&index=1&id=785eb05c&prod&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports